import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { IReportsTab } from "../../models/reports/reportsStore";
import { MetabaseChart } from "./metabaseChart";
import styles from "./reports.css";

interface Props {
  active: boolean;
  tab: IReportsTab;
}

export const Report = observer(({ active, tab }: Props) => {
  const [wasLoaded, setWasLoaded] = useState(false);

  useEffect(() => {
    if (active && !wasLoaded) {
      setWasLoaded(true);
    }
  }, [active]);

  const renderCharts = () => {
    return tab.reports.map((report) =>
      report.metabaseUrl ? (
        <div className={styles["charts-container"]} key={tab.scope + tab.dashboardView + report.id}>
          <MetabaseChart url={report.metabaseUrl} />
        </div>
      ) : (
        <></>
      )
    );
  };

  return (
    <div style={active ? {} : { display: "none" }}>
      <div className={styles.title}>{tab.label}</div>
      {wasLoaded && renderCharts()}
    </div>
  );
});
